/*
 * Author: Harper Yan
 * File Created:   dnesday, 24-07-10 02:50 pm  * Last Modified: Wednesday, 24-07-10 02:50 pm, by Harper Yan
 */

import { memo } from 'react';
import { useDialogStore } from './useDialogStore';
const Dialogs = () => {
  const {
    dialogQueue,
    hide,
    destroy
  } = useDialogStore(state => ({
    dialogQueue: state.dialogQueue,
    hide: state.hide,
    destroy: state.destroy
  }));
  return <>
      {Object.keys(dialogQueue).map(id => {
      if (!dialogQueue[id]) {
        return;
      }
      const {
        component: Component,
        props,
        options = {
          destroyOnClose: true
        }
      } = dialogQueue[id]!;
      const handleClose: {
        bivarianceHack: (event: object, reason: 'backdropClick' | 'escapeKeyDown') => void;
      }['bivarianceHack'] = (...args) => {
        if (props?.disableBackdropClose && args[1] === 'backdropClick') {
          return;
        }
        if (props?.onClose) {
          // onClose has higher priority than disableBackdropClose
          props.onClose(...args);
        }
        if (options?.destroyOnClose) {
          destroy(id);
        } else {
          hide(id);
        }
      };
      const handleExited = (node: HTMLElement) => {
        if (props?.TransitionProps?.onExited) {
          props.TransitionProps.onExited(node);
        }

        // `onExited` callbacks tell the modal to unmount the child content when closed and fully transitioned.
        destroy(id);
      };
      let extraProps = {};
      extraProps = {
        TransitionProps: {
          ...props?.TransitionProps,
          onExited: handleExited
        }
      };
      return <Component {...props} key={id} onClose={handleClose} // 这个是否有必要？
      {...options && !options.destroyOnClose && extraProps} />;
    })}
    </>;
};
export default memo(Dialogs);